import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TextInput from "../common/TextInput";
import Select from "../common/Select";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { setValueChange } from "src/store/reducers/estimateReduce";
import { isEmpty } from "lodash";

let total: any;
// 견적서 Input type 있는곳
function EstimateForm() {
  const estimateGoodsList: any = useAppSelector((state) => state.estimateReduce.estimate_goods_list);

  // 품명 클릭시 세팅되는 값
  const estimateGoods = useAppSelector((state) => state.estimateReduce.estimate_goods_update);

  const example = [
    {
      value: "ea",
      name: "ea",
    },
    {
      value: "m",
      name: "m",
    },
    {
      value: "m²",
      name: "m²",
    },
    {
      value: "py",
      name: "py",
    },
    {
      value: "set",
      name: "set",
    },
    {
      value: "대",
      name: "대",
    },
    {
      value: "식",
      name: "식",
    },
    {
      value: "인",
      name: "인",
    },
    {
      value: "자",
      name: "자",
    },
    {
      value: "줄",
      name: "줄",
    },
    {
      value: "차",
      name: "차",
    },
    {
      value: "품",
      name: "품",
    },
  ];

  const dispatch = useAppDispatch();

  const [inputs, setInputs] = useState({
    goods_name: "",
    size: "",
    qty: 0,
    unit_price: 0,
    total_price: 0,
    spec: "ea",
    etc: "",
  });

  useEffect(() => {
    dispatch(setValueChange(inputs));
  }, [inputs]);

  useEffect(() => {
    setInputs({
      ...inputs,
      goods_name: "",
      size: "",
      qty: 0,
      unit_price: 0,
      total_price: 0,
      spec: "ea",
      etc: "",
    });
    total = 0;
  }, [estimateGoodsList]);

  useEffect(() => {
    if (!isEmpty(estimateGoods)) {
      setInputs({
        ...inputs,
        goods_name: estimateGoods.goods_name,
        size: estimateGoods.size,
        qty: estimateGoods.qty,
        unit_price: estimateGoods.unit_price,
        total_price: estimateGoods.total_price,
        spec: estimateGoods.spec,
        etc: estimateGoods.etc,
      });
    }
  }, [estimateGoods]);

  const onChange = (e: any) => {
    const { value, id } = e.target;

    if (id === "unit_price") {
      if (inputs.qty > 0) {
        total = Number(value) * inputs.qty;
      } else {
        total = Number(value);
      }
    }
    if (id === "qty") {
      if (inputs.unit_price > 0) {
        total = inputs.unit_price * Number(value);
      }
    }
    const roundTotal = Math.round(total);
    if (id === "unit_price" || id === "qty") {
      const onlyNumber = value.replace(/[^0-9.]/g, "");
      setInputs({
        ...inputs,
        [id]: onlyNumber,
        total_price: roundTotal,
      });
    } else {
      setInputs({
        ...inputs,
        [id]: value,
      });
    }
  };

  return (
    <FormSet>
      <dl>
        <dt className="required">품명</dt>
        <dd>
          <TextInput variant="contained" type="text" id="goods_name" value={inputs.goods_name} name="id01" onChange={(e) => onChange(e)} />
        </dd>
      </dl>
      <dl className="divide">
        <div>
          <dt>사이즈</dt>
          <dd>
            <TextInput variant="contained" type="text" id="size" name="id02" value={inputs.size} onChange={(e) => onChange(e)} />
          </dd>
        </div>
        <div>
          <dt className="required">단위</dt>
          <dd>
            <Select size="small" options={example} defaultValue={inputs.spec} id="spec" onChange={(e) => onChange(e)} />
          </dd>
        </div>
      </dl>
      <dl className="divide">
        <div>
          <dt className="required">단가</dt>
          <dd>
            <TextInput
              variant="contained"
              pattern="\d*"
              type="text"
              id="unit_price"
              name="id03"
              value={inputs.unit_price === 0 ? "" : inputs.unit_price}
              onChange={(e) => onChange(e)}
            />
          </dd>
        </div>
        <div>
          <dt className="required">수량</dt>
          <dd>
            <TextInput variant="contained" type="text" id="qty" name="id04" value={inputs.qty === 0 ? "" : inputs.qty} onChange={(e) => onChange(e)} />
          </dd>
        </div>
      </dl>
      <dl>
        <dt>비고</dt>
        <dd>
          <TextInput variant="contained" type="text" id="etc" name="id05" value={inputs.etc} onChange={(e) => onChange(e)} />
        </dd>
      </dl>
    </FormSet>
  );
}

const FormSet = styled.div`
  padding: 20px 0;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
  > dl {
    margin-top: 15px;
    &.divide {
      ${({ theme }) => theme.flexBox.flexMixin()}
      > div:first-child {
        flex-grow: 1;
        margin-right: 15px;
      }
      > div:last-child {
        flex-basis: 40%;
      }
    }
    dt {
      position: relative;
      display: inline-block;
      color: #001827;
      font-size: 16px;
      margin-bottom: 5px;
      &.required {
        &::after {
          content: "*";
          position: absolute;
          top: -2px;
          right: -8px;
          display: block;
          font-size: 14px;
        }
      }
    }
    &:first-child {
      margin-top: 0;
    }
  }
`;

export default EstimateForm;
